module.exports = __webpack_public_path__ + "img/orsul_z.b98884f8.png";